const STORAGE_KEY = 'certClaimToastLastShownAt';
const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;

export function shouldShowCertificateClaimToast(): boolean {
  if (typeof window === 'undefined') return false;
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return true;
  const lastShown = Number.parseInt(raw, 10);
  if (Number.isNaN(lastShown)) return true;
  return Date.now() - lastShown >= TWENTY_FOUR_HOURS_MS;
}

export function markCertificateClaimToastShown(): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(STORAGE_KEY, String(Date.now()));
}

/** Clears the 24h toast throttle so the next login can see the nudge again. */
export function resetCertificateClaimToastStorage(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(STORAGE_KEY);
}
